export default "__VITE_ASSET__B5hqJ6QW__"